var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.528809,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.528809,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0894 36.0288V21.1847H14.2848V36.0288H19.0894ZM16.6871 19.158C18.3626 19.158 19.4054 18.0181 19.4054 16.5936C19.3742 15.137 18.3626 14.0288 16.7189 14.0288C15.0754 14.0288 14.0008 15.137 14.0008 16.5936C14.0008 18.0181 15.0434 19.158 16.6558 19.158H16.6871Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7156 36.0257H26.3949V27.732C26.3949 27.2881 26.4253 26.8447 26.5489 26.5274C26.8872 25.6405 27.6571 24.722 28.9499 24.722C30.643 24.722 31.3203 26.084 31.3203 28.0805V36.0257H35.9992V27.5101C35.9992 22.9483 33.6908 20.8257 30.6122 20.8257C28.0877 20.8257 26.9795 22.3142 26.3638 23.328H26.395V21.1742H21.7158C21.7772 22.5677 21.7156 36.0257 21.7156 36.0257Z",
    fill: "#006699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedInIcon.3bbac4df1276daa14fee0dfe4dba1843.svg";
export { ForwardRef as ReactComponent };